import { useEffect, useState } from "react";
import axios from '../api/axiosInstance';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";


function AdminBloodPressureHistory({ open, user, onClose, onUpdated }) {
  const [records, setRecords] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const token = localStorage.getItem("token");
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
  });
  const [endDate, setEndDate] = useState(() =>
    new Date().toISOString().split("T")[0]
  );

  const fetchRecords = async () => {
    if (!user) return;
    try {
      const res = await axios.get(`/api/BloodPressure?userid=${user.userId}&startDate=${startDate}&endDate=${endDate}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRecords(res.data);
    } catch {
      alert("查詢失敗");
    }
  };

  const handleEdit = (r) => {
    setEditingId(r.id);
    setEditData({
      recordedAt: r.recordedAt?.slice(0, 16) || "",
      systolic: r.systolic,
      diastolic: r.diastolic,
      heartRate: r.heartRate,
      notes: r.notes || "",
      isAbnormal: r.isAbnormal ?? false,
    });
  };

  const handleSave = async (id) => {
    try {
      await axios.put(
        `/api/Admin/blood-pressure/${id}`,
        { ...editData },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditingId(null);
      fetchRecords();
      if (onUpdated) onUpdated(); // ⬅️ 更新上層列表
    } catch {
      alert("更新失敗");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("確定要刪除？")) return;
    try {
      await axios.delete(`/api/Admin/blood-pressure/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchRecords();
      if (onUpdated) onUpdated(); // ⬅️ 更新上層列表
    } catch {
      alert("刪除失敗");
    }
  };

  useEffect(() => {
    if (open && user?.userId) fetchRecords();
  }, [open, user?.userId]);

  if (!open || !user) return null;

  return (
    <>
      <div
        className="modal show fade d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1055 }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{user.name} - 血壓紀錄</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body"><div className="row g-2 align-items-end mb-3">
              <div className="col-auto">
                <label className="form-label">起始日期</label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-auto">
                <label className="form-label">結束日期</label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-auto">
                <button className="btn btn-primary" onClick={fetchRecords}>
                  查詢
                </button>
              </div>
            </div>
              {records.length > 0 && (
                <div style={{ width: "100%", height: 300 }}>
                  <ResponsiveContainer>
                    <LineChart data={[...records].reverse()}>
                      <XAxis dataKey="recordedAt" />
                      <YAxis yAxisId="left" domain={["auto", "auto"]} />
                      <YAxis yAxisId="right" orientation="right" domain={["auto", "auto"]} />
                      <Tooltip />
                      <Legend />
                      <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="systolic"
                        stroke="#e74c3c"
                        name="收縮壓"
                      />
                      <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="diastolic"
                        stroke="#f39c12"
                        name="舒張壓"
                      />
                      <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="heartRate"
                        stroke="#3498db"
                        name="心跳"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              )}
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>最後編輯</th>
                      <th>時間</th>
                      <th>收縮壓</th>
                      <th>舒張壓</th>
                      <th>心跳</th>
                      <th>備註</th>
                      <th>異常</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">尚無資料</td>
                      </tr>
                    ) : (
                      records.map((r) => (
                        editingId === r.id ? (
                          <tr key={r.id}>
                            <td>{r.sourceName}</td>
                            <td>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={editData.recordedAt}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    recordedAt: e.target.value,
                                  })
                                }
                              />
                            </td>
                            <td><input className="form-control" value={editData.systolic} onChange={(e) => setEditData({ ...editData, systolic: e.target.value })} /></td>
                            <td><input className="form-control" value={editData.diastolic} onChange={(e) => setEditData({ ...editData, diastolic: e.target.value })} /></td>
                            <td><input className="form-control" value={editData.heartRate} onChange={(e) => setEditData({ ...editData, heartRate: e.target.value })} /></td>
                            <td><input className="form-control" value={editData.notes} onChange={(e) => setEditData({ ...editData, notes: e.target.value })} /></td>
                            <td>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={editData.isAbnormal}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    isAbnormal: e.target.checked,
                                  })
                                }
                              />
                            </td>
                            <td>
                              <button className="btn btn-success btn-sm me-1" onClick={() => handleSave(r.id)}>儲存</button>
                              <button className="btn btn-secondary btn-sm" onClick={() => setEditingId(null)}>取消</button>
                            </td>
                          </tr>
                        ) : (
                          <tr key={r.id}>
                            <td>{r.sourceName}</td>
                            <td>{r.recordedAt?.replace("T", " ").slice(0, 16)}</td>
                            <td>{r.systolic}</td>
                            <td>{r.diastolic}</td>
                            <td>{r.heartRate}</td>
                            <td>{r.notes}</td>
                            <td>{r.isAbnormal ? "⚠️" : "✅"}</td>
                            <td>
                              <button className="btn btn-outline-primary btn-sm me-1" onClick={() => handleEdit(r)}>編輯</button>
                              <button className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(r.id)}>刪除</button>
                            </td>
                          </tr>
                        )
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>關閉</button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
      ></div>
    </>
  );
}

export default AdminBloodPressureHistory;
